import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import AdminImageLoadingSpinner from '../Common/AdminImageLoadingSpinner';

const BoatImagePlaceholder = ({ image, onClick }) => {
  return (
    <div className="destination-image-placeholder" onClick={onClick}>
      {image ? (
        <img
          src={typeof image === 'string' ? image : URL.createObjectURL(image)}
          alt="Destination"
          className="destination-image"
        />
      ) : (
        <div className="placeholder-content">
          <FontAwesomeIcon icon={faImage} size="3x" />
        </div>
      )}
    </div>
  );
};

export default BoatImagePlaceholder;